define([
	"dojo/_base/declare",
	"csi",
	"csi/reflection",
	"csi/table/New"
], function(declare,csi,reflection,New) {

	return declare(New, {
		/**
		 * Pick up type based on switchboard
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			if (this.widget.urlSubtype != csi.EMPTY_URL) {
				view.addFixedValue(reflection.ATTR_SUBTYPE, this.widget.urlSubtype);
			}

			this.inherited(arguments);
		}
	});
});